import { IVerificationRequestInitialValues } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { storeResources } from '../resources';
import { ITechnicianConfirmationRequest, IVerificationRequest } from '../../constants/pusher';
import { ThunkConfirmValidation } from './thunks';

const initialState: IVerificationRequestInitialValues = {
  request: null,
  isPending: false,
  error: undefined,
  technicianConfirmation: null,
  verificationModalOpen: false,
  showTechnicianConfirmationModal: false,
};

const verificationRequestSlice = createSlice({
  name: storeResources.VERIFICATION_REQUEST,
  initialState,
  reducers: {
    createVerificationRequest: (state, action: PayloadAction<IVerificationRequest>) => {
      state.request = action.payload;
    },
    removeVerificationRequest: state => {
      state.request = null;
    },
    createTechnicianConfirmation: (
      state,
      action: PayloadAction<ITechnicianConfirmationRequest>,
    ) => {
      state.technicianConfirmation = action.payload;
    },
    removeTechnicianConfirmationRequest: state => {
      state.technicianConfirmation = null;
    },
    verificationModalHandler: (state, action: PayloadAction<boolean>) => {
      state.verificationModalOpen = action.payload;
    },
    showTechnicianConfirmationModalHandler: (state, action: PayloadAction<boolean>) => {
      state.showTechnicianConfirmationModal = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(ThunkConfirmValidation.fulfilled, (state, action) => {
      state.error = undefined;
      state.request = null;
      state.isPending = false;
    });

    builder.addCase(ThunkConfirmValidation.pending, (state, action) => {
      state.error = undefined;
      state.isPending = true;
    });

    builder.addCase(ThunkConfirmValidation.rejected, (state, action) => {
      state.error = action?.error?.message;
      state.isPending = false;
    });
  },
});

export default verificationRequestSlice.reducer;
export const {
  createVerificationRequest,
  removeVerificationRequest,
  createTechnicianConfirmation,
  removeTechnicianConfirmationRequest,
  verificationModalHandler,
  showTechnicianConfirmationModalHandler,
} = verificationRequestSlice.actions;
